/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
/**
 * The internal dependencies.
 */
import ExclamationIcon from '../../../../assets/images/temp/ico-exclamation.png';
import CloseButton from '../../../../components/task/close-button';

const Bar = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	background: repeating-linear-gradient(-45deg, #f43d3d, #f43d3d 15px, #f76d6d 10px, #f76d6d 30px);
	padding: 5px 0;
`;

const Icon = styled.img`
	width: 22px;
	height: 22px;
	margin-right: 5px;
`;

const Text = styled.span`
	text-align: center;
	font-size: 30px;
	font-weight: 600;
	line-height: 1;
	color: #fff;
`;

const Close = styled.span`
	position: absolute;
	top: 4px;
	right: 17px;
	display: flex;
	align-items: center;
	font-size: 14px;
	font-weight: 400;
	color: #fff;
`;

const Title = ({close}) => (
    <Bar>
        <Icon src={ExclamationIcon}/>

        <Text>Fehlermeldung </Text>

        <Close>
            <span>Schließen</span>

            <CloseButton color="#fff" onClick={close}/>
        </Close>
    </Bar>
);

export default Title;



// WEBPACK FOOTER //
// ./src/components/task/working/report/title.js